exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\n.v-icon.v-icon[data-v-14f750d3]{\n  font-size: 19px !important;\n}\n\n/* purgecss end ignore */\n\n\n", ""]);

// exports
